import { forwardRef } from "react";
import Skeleton from "react-loading-skeleton";

import "./take-home-pay-calculator.scss";

export const TakeHomePayCalculatorLoader = forwardRef((_, ref) => {
  return (
    <div ref={ref} className="take-home-pay-calculator loader">
      <div className="expert-info">
        <Skeleton circle width={"4.375rem"} height={"4.375rem"} />
        <div className="expert-info-income">
          <Skeleton width={"15rem"} height={"1.764rem"} />
          <Skeleton width={"10rem"} height={"1.764rem"} />
        </div>
      </div>
      <div className="tax-info">
        <Skeleton width={"13rem"} height={"1.764rem"} />
        <div className="tax-info-detail">
          <Skeleton width={"3rem"} height={"1.764rem"} />
          <Skeleton width={"3rem"} height={"1.764rem"} />
          <Skeleton width={"3rem"} height={"1.764rem"} />
          <Skeleton width={"3rem"} height={"1.764rem"} />
        </div>
      </div>
      <div className="take-home-info">
        <div className="take-home-info-result">
          <Skeleton
            containerClassName="tx-skeleton-container"
            width={"8rem"}
            height={"4rem"}
          />
          <Skeleton
            containerClassName="tx-skeleton-container"
            circle
            width={"2rem"}
            height={"2rem"}
          />
          <Skeleton
            containerClassName="tx-skeleton-container"
            width={"8rem"}
            height={"4rem"}
          />
        </div>
      </div>
    </div>
  );
});

TakeHomePayCalculatorLoader.displayName = "Take Home Pay Calculator Loader";
